import React, { Component } from "react";
import { Panel, PanelGroup, Accordion } from "react-bootstrap";
import { getCurrentSession } from '../../../lib/authentication';
import { PRESIGN_BUCKET_LOOKUP_KEYS } from '../../../app/constants';

export default class Logintrouble extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeKey: '',
      downloadUrl: ''
    };
    this.question1LinkRef = React.createRef();
    this.question10LinkRef = React.createRef();
    this.question11LinkRef = React.createRef();

    this.handleGenericS3PresignedURL = this.handleGenericS3PresignedURL.bind(this);
  }

  handleSelect = activeKey => {
    this.setState({ activeKey });
  };

  handleGenericS3PresignedURL = async (elementRef, bucketKey, fileName) => {
      try {
        const { accessToken } = await getCurrentSession();
        const response = await apigClient.presignedURLGenericGet(
          {
            bucketKey,
            fileName
          },
          {},
          { headers: { Authorization: accessToken } },
        );
        if (typeof response?.data?.url === 'string' && response.data.url.length > 0) {
          this.setState({
            downloadUrl: response.data.url
          }, () => elementRef.current.click())
        }
      } catch (e) {
        console.log(e.message);
      } 
  }

  renderForm() {
    return (
      <div className="container">
        <div className="LogintroubleSolution">
          <h1 className="main_head">Frequently Asked Questions</h1>

          <div className="">
            <div className="faqs_heading">
              {" "}
              Getting Started with your submission? Here are the answers to most of your questions.
            </div>

            <PanelGroup
              accordion
              id="faqs-accordion"
              activeKey={this.state.activeKey}
              onSelect={this.handleSelect}
            >
              <Panel eventKey="1">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    {" "}
                    1. Can I bind coverage in Owner's Edge?
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  You can Bind OCPs In Owners Edge. Please see instructions linked  <a
                    className="s3-link"
                    onClick={() => {
                      this.handleGenericS3PresignedURL(
                        this.question1LinkRef,
                        PRESIGN_BUCKET_LOOKUP_KEYS.ASSETS_PDFS,
                        'ARGO CONSTRUCTION OCP Bind Process.pdf'
                      )
                    }}
                  >
                    here.
                  </a> To bind Owners Interest coverage, you must email your dedicated OI Team Underwriter. Please include all “Prior to Binding” subjectivities.
                  <a
                    className="s3-link-hidden"
                    download="OCPBindProcess"
                    target="blank"
                    href={this.state.downloadUrl}
                    ref={this.question1LinkRef}
                  />
                </Panel.Body>
              </Panel>

              <Panel eventKey="2">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    2. How long is my quote valid for?
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  <span className="f_bold">90 days maximum.</span> If you would
                  like to keep the quote open beyond that date, you will need to{" "}
                  <span className="f_bold">EDIT</span> your quote to update the
                  effective date to reflect the new anticipated start date.
                </Panel.Body>
              </Panel>

              <Panel eventKey="3">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    3. What is the maximum term available?
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  Three years (36 Months)
                </Panel.Body>
              </Panel>

              <Panel eventKey="4">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    4. How often can the quote be changed?
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  As many times as needed. You can amend quotes for different
                  coverage options, revised effective dates, and change in
                  costs, etc.
                </Panel.Body>
              </Panel>

              <Panel eventKey="5">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    5. Are quotes available on an admitted basis?
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  <span className="f_bold">No, </span>all quotes are
                  non-admitted. Refer page one of the quotes for specific
                  company name.
                </Panel.Body>
              </Panel>

              <Panel eventKey="6">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    6. How do I obtain copies of the applicable forms?{" "}
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                <ul className="no_bullets">
                  <li>You can download a Policy Specimen by selecting the “Download Policy Specimen” button next to your submission, or by selecting “History”, which allows you to download policy specimens for all submitted quotes.</li>
                <li><img src={require("../../../images/faq.png")} style={{padding:"15px 15px 15px 15px"}}></img></li>
                </ul>
                </Panel.Body>
              </Panel>

              <Panel eventKey="7">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    7. How do I obtain additional coverages (HNOA, Railroad
                    protective, reinstating aggregate limits, etc.)?{" "}
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  You will need to contact your dedicated OI Team Underwriter to
                  confirm availability and pricing.
                  Requests can be made in the General Comments section at the bottom of the OI and OCP submission details page.{" "}
                </Panel.Body>
              </Panel>

              <Panel eventKey="8">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    8. Are other deductibles available?{" "}
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  No, the deductibles as noted are mandatory.
                </Panel.Body>
              </Panel>

              <Panel eventKey="9">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    9. Can I add multiple projects on one quote?{" "}
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  {" "}
                  Contact your dedicated OI Team Underwriter to verify.
                  Guidelines vary depending on number of locations, Named
                  Insured, and if the same contractor is performing all work.
                </Panel.Body>
              </Panel>

              <Panel eventKey="10">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    10. What is difference in Owners Interest and OCP’s?{" "}
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  {" "}
                  See attached link to information.{" "}
                  <a
                    className="s3-link"
                    onClick={() => {
                      this.handleGenericS3PresignedURL(
                        this.question10LinkRef,
                        PRESIGN_BUCKET_LOOKUP_KEYS.ASSETS_PDFS,
                        'ARGO CONSTRUCTION_OI vs OCP.pdf'
                      )
                    }}
                  >
                    OCP Vs OI comparison
                  </a>{" "}
                  <a
                    className="s3-link-hidden"
                    download="OIvsOCP"
                    alt="OIvsOCP"
                    target="blank"
                    href={this.state.downloadUrl}
                    ref={this.question10LinkRef}
                  />
                </Panel.Body>
              </Panel>

              <Panel eventKey="11">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    11. What is the difference in Owners Interest
                    Deductible Warranty/Standard/Conditional/BI Excluded coverage?{" "}
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  See attached link to information.{" "}
                  <a
                    className="s3-link"
                    onClick={() => {
                      this.handleGenericS3PresignedURL(
                        this.question11LinkRef,
                        PRESIGN_BUCKET_LOOKUP_KEYS.ASSETS_PDFS,
                        'OI and OCP Coverage Options.pdf'
                      )
                    }}
                  >
                    Difference in Owners Interest Deductible Warranty/Standard/Conditional/BI
                    Excluded coverage
                  </a>
                  <a
                    className="s3-link-hidden"
                    download="OI and OCP Coverage Options"
                    alt="BaseCoverages"
                    target="blank"
                    href={this.state.downloadUrl}
                    ref={this.question11LinkRef}
                  />
                </Panel.Body>
              </Panel>

              <Panel eventKey="12">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    12. Does the Direct Hired Contractors Required Minimum
                    Limits apply to <span className="f_underline">all</span>{" "}
                    contractors on the job?{" "}
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  No, only the contractors directly hired, directly paid and
                  contracted with by the Owner. Refer to definition of
                  “contractor” on form U658OI / U658OI LLE for Owners Interest
                  or form CG0009 for OCP’s.
                </Panel.Body>
              </Panel>

              <Panel eventKey="13">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    13. What should be included in “project costs”?{" "}
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  <ul className="no_bullets mleft_15">
                    For Owners Interest, the project costs include:
                    <li>(a) Labor: the costs of all labor, work or sublet. </li>
                    <li>
                      (b) Material: costs of all materials, transportations,
                      delivery fees and warehousing; equipment furnished used or
                      delivered for use in the execution of the work. {" "}
                    </li>
                    <li>(c)
                      Overhead: overhead costs, general conditions and
                      contingencies.</li>
                  </ul>

                  <ul className="no_bullets mleft_15">
                    For OCP’s, the cost is the amount included in the
                    contractual agreement.
                  </ul>
                </Panel.Body>
              </Panel>

              <Panel eventKey="14">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    14. Will you include additional insureds?{" "}
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  {" "}
                  For Owners Interest, the interest of the AI related to the
                  project must be confirmed. If we agree to add, there is a flat
                  $250 AP per named AI form provided subject to similar named AI
                  forms from the direct hired contractor. For OCP’s, there are
                  limited AI’s allowed since this coverage is supplementary to
                  the contractors GL coverage, and the contractor should provide
                  AI status. Refer request to your dedicated OI Team
                  underwriter.
                </Panel.Body>
              </Panel>

              <Panel eventKey="15">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    15. Will you cover occupancy under an Owners Interest?{" "}
                  </Panel.Title>
                </Panel.Heading>

                <Panel.Body collapsible className="mleft_15">
                  {" "}
                  No, occupancy coverage will not be provided. If the building
                  is occupied during project work (subject to underwriter review
                  and approval), a separate COI from the Owner is required prior
                  to binding to confirm current LRO coverage in place.{" "}
                </Panel.Body>
              </Panel>
              <Panel eventKey="16">
                <Panel.Heading>
                  <Panel.Title toggle className="faqs">
                    16. What is the maximum number of directly hired contractors that is acceptable?{" "}
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible className="mleft_15">
                  {" "}
                  For OI - we will allow up to 3 directly hired contractors over the course of an entire project. If 4 or more contractors are being hired by the Named Insured, the project is not eligible for our OI product. <br></br>
For OCP - we will allow up to 1 directly hired contractor over the course of an entire project. If 2 or more contractors are being hired by the Named Insured, the project is not eligible for our OCP product. <br></br>
Please note: These qualifications do not exempt it from being eligible for a Middle Market or a New York Construction quote. Please submit directly to submissions@argogroupus.com for this option. {" "}
                </Panel.Body>
              </Panel>
            </PanelGroup>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return <div>{this.renderForm()}</div>;
  }
}
